import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/estimations/page.tsx");
